import http from "@/utils/axios";
import cookie from "@/utils/cookie";

//使用vuex 用于判断用户是否有权限操作
// vuex需要设置没刷新一个下页面发送请求获取页面控制的权限
// 需要在前端或者后端设置一个常量来保存
// 后端需要另外添加一个设置身份的接口
const state = {
  //用户的权限(默认的权限)
  userPower: "unapprove-member",
  //超级管理员
  IS_SUPER_MANAGER: "super-manager",
  //系统管理员
  IS_SYSTEM_MANAGER: "system-manager",
  //机构管理员
  IS_DEPARTMENT_MANAGER: "department-manager",
  //普通用户
  IS_MEMBER: "member",
  //省中医用户
  IS_GPHOTCM: false,
  //未审核的用户
  IS_UNAPPROVE_MEMBER: "unapprove-member",
  //部门管理员
  deptPower: false,
  //系统管理员
  systemPower: false,
  //超级管理员
  superPower: false,
  //普通成员
  memberPower: false,
  //未审核的成员
  unApproveMember: true,
  //角色code和角色名的分隔符
  ROLE_CODE_OR_NAME_SEPARATOR: "、",

  isShowUnApprove:false,
}

const mutations = {
  //获取用户的最大权限
  getUserPower(state) {
    let token = cookie.getCookie("token")
    let obj = {
      token: token
    }
    state.isShowUnApprove = false;
    http.post(window.config.api.baseUrl + '/eims-api/user/userPower', obj).then(value => {
      if (value.data.code === '00000') {
        state.userPower = value.data.data.auth
        state.IS_GPHOTCM = value.data.data.IS_GPHOTCM
        let roleCodes =  state.userPower.split(state.ROLE_CODE_OR_NAME_SEPARATOR)
        //将用户的权限信息设置到state中
        mutations.setUserPowerToState(state, roleCodes)
        // console.log(state.unApproveMember)
        // state.isShowUnApprove = state.unApproveMember;
      }
    }).finally(() => {
      state.isShowUnApprove = true;
    })
  },

  setUserPowerToState(state, roleCodes) {
    if (roleCodes.includes(state.IS_SUPER_MANAGER)) {
      state.superPower = true
      state.systemPower = true
      state.deptPower = true
      state.memberPower = true
      state.unApproveMember = false
    } else if (roleCodes.includes(state.IS_SYSTEM_MANAGER)) {
      state.superPower = false
      state.systemPower = true
      state.deptPower = true
      state.memberPower = true
      state.unApproveMember = false
    } else if (roleCodes.includes(state.IS_DEPARTMENT_MANAGER)) {
      state.superPower = false
      state.systemPower = false
      state.deptPower = true
      state.memberPower = true
      state.unApproveMember = false
    } else if (roleCodes.includes(state.IS_MEMBER)) {
      state.superPower = false
      state.systemPower = false
      state.deptPower = false
      state.memberPower = true
      state.unApproveMember = false
    } else if (roleCodes.includes(state.IS_UNAPPROVE_MEMBER)) {
      state.superPower = false
      state.systemPower = false
      state.deptPower = false
      state.memberPower = false
      state.unApproveMember = true
    }
  }

}

const actions = {
  getUserPower: ({commit, state}) => commit('getUserPower'),
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/userPowerStore.js